import { ModuleWithProviders, NgModule, inject, provideAppInitializer } from '@angular/core';
import { TranslateLoader, TranslateModule, TranslateParser } from '@ngx-translate/core';
import { DictionaryTranslateLoader } from './service/dictionary-loader.service';
import { HttpClient } from '@angular/common/http';
import { LocalStorageService } from '@cash/shared/local-storage';
import { DictionaryReactiveService } from './service/dictionary-reactive.service';
import { AuthenticationFacade } from '@cash/shared/authentication';
import { TranslateSingleBracketParser } from './parser/single-bracket-parser';
import { lastValueFrom } from 'rxjs';

function initDictionaryServiceFactory(dictionaryReactiveSevice: DictionaryReactiveService) {
  return async () => lastValueFrom(dictionaryReactiveSevice.initialize());
}

@NgModule({
  imports: [
    TranslateModule.forRoot({
      extend: true,
      isolate: false,
      parser: {
        provide: TranslateParser,
        useClass: TranslateSingleBracketParser,
      },
      loader: {
        provide: TranslateLoader,
        useClass: DictionaryTranslateLoader,
        deps: [HttpClient, LocalStorageService, AuthenticationFacade],
      },
    }),
  ],
  exports: [TranslateModule],
  providers: [
    DictionaryReactiveService,
    provideAppInitializer(() => {
        const initializerFn = (initDictionaryServiceFactory)(inject(DictionaryReactiveService));
        return initializerFn();
      }),
  ],
})
export class DictionaryModuleForRoot {}

@NgModule({
  imports: [TranslateModule],
  exports: [TranslateModule],
})
export class SharedDictionaryModule {
  static forRoot(): ModuleWithProviders<TranslateModule> {
    return {
      ngModule: DictionaryModuleForRoot,
    };
  }
}
